import { Component } from 'react';
import { connect } from 'react-redux';
import { parse } from 'hub-http/helpers/params';
import * as AppActions from '../actions/AppActions';
import { DEBUG_OPTION_KEYS } from '../constants';
import { debug } from '../utils/env';
import UniversalEditorContainer from './UniversalEditorContainer';
import { getBusinessUnitId } from '../selectors/appSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapDispatchToProps = {
  setOptions: AppActions.setOptions
};
const mapStateToProps = state => {
  return {
    businessUnitId: getBusinessUnitId(state)
  };
};
class UniversalEditorAppContainer extends Component {
  componentDidMount() {
    const {
      setOptions,
      businessUnitId
    } = this.props;
    const queryParams = parse(window.location.search.slice(1));
    const debugOptions = DEBUG_OPTION_KEYS.reduce((final, key) => {
      final[key] = queryParams[key] === 'true';
      return final;
    }, {});
    let redirectUrl = queryParams['redirectUrl'];
    if (redirectUrl && !redirectUrl.startsWith('/')) {
      redirectUrl = `/${redirectUrl}`;
    }
    setOptions(Object.assign({}, debugOptions, {
      debugMode: !!debug(),
      fromAppName: this.props.fromAppName,
      businessUnitId,
      redirectUrl: redirectUrl && `${window.location.origin}${redirectUrl}`,
      testMode: false
    }));
  }
  render() {
    const {
      fromAppName,
      AsyncComponentContext,
      reloadIframePreview,
      trackUpdateThemeSettings,
      handleOpenRevisionsModal,
      handleClosePatagoniaSidebar,
      templatePath
    } = this.props;
    return /*#__PURE__*/_jsx(UniversalEditorContainer, {
      fromAppName: fromAppName,
      AsyncComponentContext: AsyncComponentContext,
      reloadIframePreview: reloadIframePreview,
      trackUpdateThemeSettings: trackUpdateThemeSettings,
      handleOpenRevisionsModal: handleOpenRevisionsModal,
      handleClosePatagoniaSidebar: handleClosePatagoniaSidebar,
      templatePath: templatePath
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(UniversalEditorAppContainer);